import './App.css';
import ProfileCard from './Components/ProfileCard';

function App() {
  return (
    <>
      <ProfileCard></ProfileCard>
    </>
  );
}

export default App;
